export default __webpack_public_path__ + "static/good-firms-2ca0d392e2e1f48443f1d2b9a91a280e.svg";